import { NgModule, Injector } from '@angular/core';
import { EForm } from './eform';
import { EFormPage } from './page';
import { EFormSection } from './section';
import { ImportMaterialModule } from '../material.module';
import { EFormField } from './field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { createCustomElement } from '@angular/elements';
import { CommonModule } from '@angular/common';
import { ImportPrimeModule } from '../prime.module';
import { NgxBootstrapSliderModule } from 'ngx-bootstrap-slider';

@NgModule({
  declarations: [
    EForm,
    EFormPage,
    EFormSection,
    EFormField,
    // InputString, InputNumber, InputChips, InputSelect, InputBoolean, InputDate, InputTime,
    // InputMenu, LookupMenuItem, LookupTree,
    // SmartToolbar,
  ],
  imports: [
    CommonModule,
      // BrowserModule,
      FormsModule,
      ReactiveFormsModule,
      ImportMaterialModule,
      ImportPrimeModule,
      NgxBootstrapSliderModule,
  ],
  exports: [
      EForm,
      EFormPage,
      EFormSection,
      EFormField,
      // InputString, InputNumber, InputChips, InputSelect, InputBoolean, InputDate, InputTime,
      // InputMenu, LookupMenuItem, LookupTree,
      // SmartToolbar,
  ],
  entryComponents: [
      EForm,
      EFormPage,
      EFormSection,
      EFormField,
      // LookupMenuItem
  ],
  providers: [
  ]
})
export class EFormModule {

  constructor(private injector: Injector) {
  
      try {
          if (!customElements.get('ess-eform')) {
            const eform = createCustomElement(EForm, {injector: this.injector});

            customElements.define('ess-eform', eform as any);
            console.log("Registered element (with distinct selector!!!!!!) " + "ess-eform");
          }
      } catch(err) { console.error(err) }
  }  
}